module.exports = __webpack_public_path__ + "static/media/January2021Newsletter.2cbd326b.pdf";